import { Action } from 'redux';
import { DOCTOR_VENDOR_TYPE } from '../enums/doctor-vendor-type.enum';

export const DOCTOR_VENDOR_TYPE_STATE_REDUX_ID = 'DoctorVendorType';

export interface DoctorVendorTypeState {
    vendorType: DOCTOR_VENDOR_TYPE;
}

export class DoctorAction implements Action {
  type: string;
  vendorType: DOCTOR_VENDOR_TYPE;
}

const INITIAL_STATE: DoctorVendorTypeState = {
  vendorType: null
};

export const SET_VENDOR_TYPE = 'SET_VENDOR_TYPE';
export function setProviderVendorType(vendorType: DOCTOR_VENDOR_TYPE): DoctorAction {
  return { type: SET_VENDOR_TYPE, vendorType };
}

export function DoctorVendorType( state: DoctorVendorTypeState = INITIAL_STATE, action: DoctorAction ) {

  const copiedState: DoctorVendorTypeState = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {

    case SET_VENDOR_TYPE:
      copiedState.vendorType = action.vendorType;
      return Object.assign({}, state, copiedState);
    default:
      return state;
  }
}
